export default "__VITE_ASSET__c5f0c1a9__"